import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
  Quotation, QuotationCreateDTO, QuotationRejectDTO, QuotationPage,
} from '../interfaces/sales/quotation.interface';
import { SalesInvoice } from '../interfaces/sales/salesInvoice.interface';

export const QuotationService = {
  listByInstitution: async (institutionId: string, page = 0, size = 10,
    owner: { salespersonId?: string; unassigned?: boolean } = {}): Promise<QuotationPage> =>
    (await axios.get(`${ENDPOINTS.QUOTATION.LIST_BY_INSTITUTION(institutionId)}?page=${page}&size=${size}`, { params: owner })).data,
  getById: async (id: string): Promise<Quotation> =>
    (await axios.get(ENDPOINTS.QUOTATION.GET_BY_ID(id))).data,
  create: async (dto: QuotationCreateDTO): Promise<Quotation> =>
    (await axios.post(ENDPOINTS.QUOTATION.CREATE, dto)).data,
  update: async (id: string, dto: QuotationCreateDTO): Promise<Quotation> =>
    (await axios.put(ENDPOINTS.QUOTATION.UPDATE(id), dto)).data,
  remove: async (id: string): Promise<void> =>
    (await axios.delete(ENDPOINTS.QUOTATION.DELETE(id))).data,
  send: async (id: string): Promise<Quotation> =>
    (await axios.post(ENDPOINTS.QUOTATION.SEND(id))).data,
  confirm: async (id: string): Promise<Quotation> =>
    (await axios.post(ENDPOINTS.QUOTATION.CONFIRM(id))).data,
  reject: async (id: string, dto: QuotationRejectDTO): Promise<Quotation> =>
    (await axios.post(ENDPOINTS.QUOTATION.REJECT(id), dto)).data,
  convert: async (id: string): Promise<SalesInvoice> =>
    (await axios.post(ENDPOINTS.QUOTATION.CONVERT(id))).data,
  clone: async (id: string): Promise<Quotation> =>
    (await axios.post(ENDPOINTS.QUOTATION.CLONE(id))).data,
  downloadPdf: async (id: string): Promise<Blob> =>
    (await axios.get(ENDPOINTS.QUOTATION.PDF(id), { responseType: 'blob' })).data,
  withdrawApproval: async (id: string): Promise<Quotation> =>
    (await axios.post(ENDPOINTS.QUOTATION.WITHDRAW_APPROVAL(id))).data,
  email: async (id: string): Promise<void> =>
    (await axios.post(ENDPOINTS.QUOTATION.EMAIL(id))).data,
};
